import React from 'react';
import { Button, Col, Form, Input, Row, Select, Space, theme } from 'antd';
import { EnumNetworkOwnership, ICustomerSearchParams } from '../../../common/models';
import { getEnumValues } from '../../../common/utils';

const { Option } = Select;

interface ICustomerSearchFormProps {
  onSearch: (searchParams?: ICustomerSearchParams) => void;
}

const CustomerSearchForm: React.FC<ICustomerSearchFormProps> = ({onSearch}) => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    borderRadius: token.borderRadiusLG,
  };

  const getFields = () => {
    return [
      <Col
        xs={24} // mobile: 1 per row
        sm={24} // small: 2 per row
        md={12} // medium: 3 per row 
        lg={6}  // large: 4 per row
        key='customerId'
        style={{ padding: 10}}
      >
        <Form.Item
          name='customerId'
          label='Customer ID'
          style={{ margin: 0 }}
        >
          <Input />
        </Form.Item>
      </Col>,
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        key='name'
        style={{ padding: 10}}
      >
        <Form.Item
          name='name'
          label='Customer Name'
          style={{ margin: 0 }}
        >
          <Input />
        </Form.Item>
      </Col>,
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        key='networkOwnership'
        style={{ padding: 10}}
      >
        <Form.Item
          name='networkOwnership'
          label='Network Ownership'
          initialValue=''
          style={{ margin: 0 }}
        >
          <Select>
            <Option value='' key='all'>All</Option>
            {
              getEnumValues(EnumNetworkOwnership).map(value => <Option value={value} key={value}>{value}</Option>)
            }
          </Select>
        </Form.Item>
      </Col>,
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        key='actions'
        style={{ padding: 10}}
      >
        <Space size="small">
          <Button type="primary" htmlType="submit">
            Search
          </Button>
          <Button
            htmlType="submit"
            onClick={() => {
              form.resetFields();
            }}
          >
            Clear
          </Button>
        </Space>
      </Col>
    ];
  };

  return (
    <Form form={form} name="customer_search" style={formStyle} onFinish={onSearch}>
      <Row gutter={24} style={{ marginLeft: 0, marginRight: 0 }}>{getFields()}</Row>
    </Form>
  );
};

export default CustomerSearchForm;